import { Col, Row } from 'antd'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { FaPlane } from "react-icons/fa"
import { getCancelChargePolicy, getVendorCancelFareRule } from '../../../services/flight/flightServices'

const FlightsInformation = ({ oneWayData }) => {

    const [cancelPolicyData, setCancelPolicyData] = useState(null);
    const cancellationCharges = cancelPolicyData?.data?.formattedCharges?.cancellationCharges || [];
    const rescheduleCharges = cancelPolicyData?.data?.formattedCharges?.rescheduleCharges || [];

    const [vendorCancelFareRule, setVendorCancelFareRule] = useState(null);
    const [loading, setLoading] = useState(false);

    const fetchVendorCancelFareRule = () => {
        setLoading(true);

        const payload = {
            TraceId: oneWayData?.traceId,
            ResultIndex: oneWayData?.flightId,
        };

        getVendorCancelFareRule(payload)
            .then((data) => {
                setVendorCancelFareRule(data);
            })
            .catch((error) => {
                console.error("Failed to fetch cancel policy:", error);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        if (oneWayData?.vendor === "TBO") {
            fetchVendorCancelFareRule();
        }
    }, [oneWayData]);


    const fetchCancelPolicy = async (flightItem) => {
        try {
            setLoading(true);
            const payload = {
                id: oneWayData?.priceOptions?.[0]?.id,
                flowType: "SEARCH"
            };
            const data = await getCancelChargePolicy(payload);
            setCancelPolicyData(data);
        } catch (error) {
            console.error('Failed to fetch cancel policy:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (oneWayData?.vendor === "TripJack") {
            fetchCancelPolicy();
        }
    }, [oneWayData]);

    return (
        <>
            <div className='mb-4'>
                <h4 className="mb-2">Flight Information</h4>
                <div className='flight-details-border mb-4'>
                    {oneWayData?.onwardFlight?.map((flightInformation, i) => (
                        <React.Fragment key={i}>
                            <Row
                                gutter={20}
                                className="gx-lg-5 gx-3 gy-4 align-items-center py-2 px-3"
                            >
                                <Col md={5} className="d-flex d-md-block align-items-center mb-3 mb-md-0">
                                    <div className="d-start fl-pic">
                                        <img
                                            className="img-collection result-flight"
                                            src={`https://d1mmwnce2x2c2z.cloudfront.net/airline/${flightInformation?.flightCode}.gif`}
                                            alt="logo"
                                        />
                                    </div>
                                    <div className="d-end fl-title ps-2 ps-md-0">
                                        <small className="text-dark fw-medium">
                                            {flightInformation?.airline}
                                        </small>
                                        <small>{flightInformation?.flightNumber}</small>
                                    </div>
                                </Col>
                                <Col xs={24} md={19}>
                                    <Row gutter={16} className="row gx-3 align-items-center">
                                        <Col md={8} xs={7}>
                                            <div className="text-dark fw-bold">
                                                <h5>{flightInformation?.origin}{" "}</h5>
                                                {moment(flightInformation?.departureTime).format('HH:mm')}
                                            </div>
                                            <small className="text-muted">
                                                {flightInformation?.originCity}
                                            </small>
                                        </Col>

                                        <Col md={8} xs={10} className="text-center px-0">
                                            <div className="flightLine departure">
                                                <FaPlane className="flight-takeoff" />
                                                <div></div>
                                                <div></div>
                                                <p>
                                                    {moment.duration(flightInformation?.duration, 'minutes').hours() + 'H ' +
                                                        moment.duration(flightInformation?.duration, 'minutes').minutes() + 'M'}
                                                </p>
                                            </div>
                                        </Col>

                                        <Col md={8} xs={7} className='text-end'>
                                            <div className="text-dark fw-bold">
                                                <h5>{flightInformation?.destination}{" "}</h5>
                                                {moment(flightInformation?.arrivalTime).format('HH:mm')}
                                            </div>
                                            <small className="text-muted">
                                                {flightInformation?.destinationCity}
                                            </small>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>

                            {i < oneWayData?.onwardFlight?.length - 1 && (
                                <div className="text-center label bg-light-success text-success py-1">
                                    {oneWayData?.connected_times?.map((layover, index) => (
                                        index === i && (
                                            <div key={index}>
                                                {moment.duration(layover?.cT, "minutes").hours() + 'h ' +
                                                    moment.duration(layover?.cT, "minutes").minutes() + 'm Layover in ' + layover?.city}
                                            </div>
                                        )
                                    ))}
                                </div>
                            )}
                        </React.Fragment>
                    ))}
                </div>

                {oneWayData?.returnFlightData && (
                    <span className="label bg-light-success text-success me-2 my-3">Return</span>
                )}
                <div className='flight-details-border'>
                    {oneWayData?.returnFlightData?.map((flightInformation, i) => (
                        <React.Fragment key={i}>
                            <Row
                                gutter={20}
                                className="gx-lg-5 gx-3 gy-4 align-items-center py-2 px-3"
                            >
                                <Col md={5} className="d-flex d-md-block align-items-center mb-3 mb-md-0">
                                    <div className="d-start fl-pic">
                                        <img
                                            className="img-collection result-flight"
                                            src={`https://d1mmwnce2x2c2z.cloudfront.net/airline/${flightInformation?.flightCode}.gif`}
                                            alt="logo"
                                        />
                                    </div>
                                    <div className="d-end fl-title ps-2 ps-md-0">
                                        <small className="text-dark fw-medium">
                                            {flightInformation?.airline}
                                        </small>
                                        <small>{flightInformation?.flightNumber}</small>
                                    </div>
                                </Col>
                                <Col xs={24} md={19}>
                                    <Row gutter={16} className="row gx-3 align-items-center">
                                        <Col md={8} xs={24}>
                                            <div className="text-dark fw-bold">
                                                {flightInformation?.origin}{" "}
                                                {moment(flightInformation?.departureTime).format('HH:mm')}
                                            </div>
                                            <small className="text-muted">
                                                {flightInformation?.originCity}
                                            </small>
                                        </Col>

                                        <Col md={8} xs={24} className="text-center">
                                            <div className="flightLine departure">
                                                <FaPlane className="flight-takeoff" />
                                                <div></div>
                                                <div></div>
                                                <p>
                                                    {moment.duration(flightInformation?.duration, 'minutes').hours() + 'H ' +
                                                        moment.duration(flightInformation?.duration, 'minutes').minutes() + 'M'}
                                                </p>
                                            </div>
                                        </Col>

                                        <Col md={8} xs={24}>
                                            <div className="text-dark fw-bold">
                                                {flightInformation?.destination}{" "}
                                                {moment(flightInformation?.arrivalTime).format('HH:mm')}
                                            </div>
                                            <small className="text-muted">
                                                {flightInformation?.destinationCity}
                                            </small>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>

                            {i < oneWayData?.returnFlightData?.length - 1 && (
                                <div className="text-center label bg-light-success text-success py-1">
                                    {oneWayData?.return_connected_times?.map((layover, index) => (
                                        index === i && (
                                            <div key={index}>
                                                {moment.duration(layover?.cT, "minutes").hours() + 'h ' +
                                                    moment.duration(layover?.cT, "minutes").minutes() + 'm Layover in ' + layover?.city}
                                            </div>
                                        )
                                    ))}
                                </div>
                            )}
                        </React.Fragment>
                    ))}
                </div>
            </div>

            <div className='mb-4'>
                <h4 className="mb-2">Fare Details</h4>
                <table>
                    <tbody>
                        <tr>
                            <td>Base Fare (1 Adult)</td>
                            <td>₹{oneWayData?.priceOptions?.[0]?.baseFare}</td>
                        </tr>
                        <tr>
                            <td>Taxes and Fees (1 Adult)</td>
                            <td>₹{oneWayData?.priceOptions?.[0]?.taxFare}</td>
                        </tr>
                        <tr>
                            <td>Total Fare (1 Adult)</td>
                            <td>₹{oneWayData?.priceOptions?.[0]?.totalFare}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            {/* <div className="mb-4">
                <h4 className="mb-3">Baggage Rules</h4>
                {oneWayData?.sI?.map((segment, index) => {
                    const baggageKey = segment.id;
                    const baggageDetails = oneWayData?.priceOptions?.[0]?.tai?.tbi?.[baggageKey]?.[0]?.ADULT;

                    return (
                        <div key={index} className="card-body mb-4">
                            <div className="d-flex align-items-center mb-2">
                                <div className="d-start fl-pic">
                                    <img
                                        className='img-collection result-flight'
                                        src={`https://d1mmwnce2x2c2z.cloudfront.net/airline/${segment?.fD?.aI?.code}.gif`}
                                        alt="logo"
                                    />
                                </div>
                                <div className="d-end fl-title ps-2">
                                    <p className="text-dark fw-medium">
                                        <b>{segment?.da?.cityCode} - {segment?.aa?.cityCode}</b> {" "}
                                        ({segment?.fD?.aI?.code}-{segment?.fD?.fN})
                                    </p>
                                </div>
                            </div>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Baggage Type</th>
                                        <th><MdLuggage /> Check-In</th>
                                        <th><MdOutlineWorkOutline /> Cabin</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Adult</td>
                                        <td>{baggageDetails?.iB || "N/A"}</td>
                                        <td>{baggageDetails?.cB || "N/A"}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    );
                })}
            </div> */}

            {oneWayData?.vendor === "TripJack" &&
                <div>
                    <h4 className="mb-2">Cancellation Rules</h4>
                    <div className="card">
                        <div className="card-header d-md-flex justify-content-between align-items-center">
                            <div className='d-flex align-items-center mb-3 mb-md-0'>
                                <div className="d-start fl-pic">
                                    <img
                                        className='img-collection result-flight'
                                        src={`https://d1mmwnce2x2c2z.cloudfront.net/airline/${oneWayData?.flightCode}.gif`}
                                        alt="logo"
                                    />
                                </div>

                                <div className="d-end fl-title ps-2">
                                    <p className="text-dark fw-medium">
                                        <b>{oneWayData?.onwardFlightDetails?.daCity} - {oneWayData?.onwardFlightDetails?.aaCity} </b>
                                    </p>
                                </div>

                            </div>
                            <div>
                                <span className="label bg-light-success text-success me-2 fw-bold py-1 px-2 rounded">Partially Refundable</span>
                            </div>
                        </div>
                        <div className="card-body">
                            <Row gutter={16}>
                                <Col md={12} xs={24} className='mb-4 mb-md-0'>
                                    <strong>Cancellation Charges</strong>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>If cancelled</th>
                                                <th>Charges</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {cancellationCharges.map((charge, index) => (
                                                <tr key={index}>
                                                    <td>{charge.description}</td>
                                                    <td>{charge.charges.startsWith('Non') ? charge.charges : `₹${charge.charges}`}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </Col>
                                <Col md={12} xs={24}>
                                    <strong>Reschedule Charges</strong>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>If rescheduled</th>
                                                <th>Charges</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {rescheduleCharges.map((charge, index) => (
                                                <tr key={index}>
                                                    <td>{charge.description}</td>
                                                    <td>{charge.charges.startsWith('Non') ? charge.charges : `₹${charge.charges}`}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>
            }

            {oneWayData?.vendor === "TBO" &&
                <div>
                    <h4 className="mb-2">Cancellation Rules</h4>
                    <div className="card">
                        <div className="card-header d-md-flex justify-content-between align-items-center">
                            <div className='d-flex align-items-center mb-3 mb-md-0'>
                                <div className="d-start fl-pic">
                                    <img
                                        className='img-collection result-flight'
                                        src={`https://d1mmwnce2x2c2z.cloudfront.net/airline/${oneWayData?.flightCode}.gif`}
                                        alt="logo"
                                    />
                                </div>

                                <div className="d-end fl-title ps-2">
                                    <p className="text-dark fw-medium">
                                        <b>{vendorCancelFareRule?.fareRules?.[0]?.origin} - {vendorCancelFareRule?.fareRules?.[0]?.destination} </b>
                                    </p>
                                </div>

                            </div>
                            <div>
                                <span className="label bg-light-success text-success me-2 fw-bold py-1 px-2 rounded">Partially Refundable</span>
                            </div>
                        </div>
                        <div className="card-body">
                            {loading ? (
                                <p>Loading...</p>
                            ) : vendorCancelFareRule?.fareRules?.[0]?.fareRuleDetails ? (
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: vendorCancelFareRule.fareRules[0].fareRuleDetails,
                                    }}
                                />
                            ) : (
                                <p>No details available</p>
                            )}
                        </div>


                    </div>
                </div>
            }

        </>
    )
}

export default FlightsInformation